import React, { useState, useEffect } from 'react';
import { useGlobal } from 'reactn';
import Card from '../../common/card/Card';
import MeterInput from '../../common/meterInput/MeterInput';
import Button from '../../common/button/Button';
import meterReadIcon from '../../assets/meterReadIcon.png';
import sendIcon from '../../assets/sendIcon.png';
import NeedHelp from '../../common/NeedHelpMeter';
import { Checkbox } from 'antd';

import api from '../../../api/';

const MeterRead = ({ customerSvcInfo, ...rest }) => {
  const [reading, setReading] = useState(['', '', '', '']);
  const [serviceAccounts] = useGlobal('serviceAccounts');
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );
  const [user] = useGlobal('user');
  const selectedServiceAccount = serviceAccounts[selectedServiceAccountIndex];
  const [currentMeterRead, setCurrentMeterRead] = useState(null);
  const [overrideWarning, setOverrideWarning] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [confirmation, setConfirmation] = useState(false);
  const [confirmationData, setConfirmationData] = useState({});

  // useEffect dependancy updated to prevent eslint warning and infinte loop.
  useEffect(() => {
    setCurrentMeterRead(selectedServiceAccount.meterData);
  }, [selectedServiceAccount.meterData]);

  if (selectedServiceAccount === undefined) {
    return <h4>Loading Account Data...</h4>;
  }

  const meterReadChangeHandler = (e) => {
    let inputId = parseInt(e.target.id, 10);
    let input = document.getElementById(inputId.toString());
    let newReading = [...reading];
    newReading[e.target.id] = e.target.value;
    if (input?.value !== '' && inputId < 3) {
      let updatedId = inputId + 1;
      input = document.getElementById(updatedId);
      input.focus();
      input.select();
    } else console.log({ message: 'NO MORE INPUTS...' });
    setReading(newReading);
    setError(null);
  };

  const overrideCheckboxHandler = (e) => {
    setOverrideWarning(e.target.checked);
  };

  const submitMeterReadHandler = async () => {
    setLoading(true);
    const { NEXT_BILL_DATE, BILL_STATUS } = currentMeterRead.data;

    const accountNo = selectedServiceAccount.data.ACCOUNT;
    const meterData = {
      accountNumber: accountNo,
      overrideReadWarning: overrideWarning ? 1 : 0,
      billStatus: parseInt(BILL_STATUS, 10),
      read: parseInt(reading.join(''), 10),
      billDate: NEXT_BILL_DATE,
      email: user.email,
    };

    const res = await api.submitMeterRead(accountNo, meterData);
    if (res.error) {
      setError(res.error);
      setLoading(false);
    } else {
      setConfirmationData({
        meterRead: meterData.read,
        msg: res.status.message,
      });
      setReading(['', '', '', '']);
      setConfirmation(true);
      setLoading(false);
    }
  };

  const renderConfirmation = () => (
    <Card
      className="w-full lg:w-1/3 "
      title="Meter Read"
      {...rest}
      serviceRequestColor
    >
      <div
        className="w-full h-full flex-col"
        onClick={() => {
          setConfirmation(false);
          setError(null);
        }}
      >
        <img className="w-7 h-6 mx-auto mb-5" src={sendIcon} alt="send-icon" />
        <h3 className="font-bold mx-auto mb-8 text-center">METER READ SENT!</h3>
        <p className="font-bold mx-auto text-center">Thank You.</p>
        <p className="font-bold mx-auto text-center">
          Meter Read: {confirmationData.meterRead}
        </p>
        <br />
        <p className="font-bold mx-auto text-center" style={{ color: 'red' }}>
          {confirmationData.msg}
        </p>
      </div>
    </Card>
  );

  const renderError = () => (
    <>
      <p className="text-red-600 mt-5 mb-0 mx-auto">{error}</p>
      <Checkbox
        className="flex mt-2"
        onChange={(e) => overrideCheckboxHandler(e)}
      >
        {renderCheckboxLabel()}
      </Checkbox>
    </>
  );

  const renderCheckboxLabel = () => (
    <p className="text-sm text-blue">
      I have verified that the read entered above is correct.
    </p>
  );

  const renderInputs = () => (
    <Card
      className="w-full lg:w-1/3"
      bodyClassName="justify-between"
      title="Meter Read"
      serviceRequestColor
      {...rest}
    >
      <div>
        <p className="mb-4 font-bold leading-relaxed">
          Enter the first 4 digits of your meter read, INCLUDING all zeros
        </p>
        <section className="flex justify-between">
          <MeterInput
            id="0"
            onChange={meterReadChangeHandler}
            disabled={loading}
            value={reading[0]}
          />
          <MeterInput
            id="1"
            onChange={meterReadChangeHandler}
            disabled={loading}
            value={reading[1]}
          />
          <MeterInput
            id="2"
            onChange={meterReadChangeHandler}
            disabled={loading}
            value={reading[2]}
          />
          <MeterInput
            id="3"
            onChange={meterReadChangeHandler}
            disabled={loading}
            value={reading[3]}
          />
        </section>
        {error && !confirmation && renderError()}

        <div className="flex justify-start items-center my-4">
          <span className="font-bold">Previous Meter Read: </span>
          <span className="ml-4 font-bold text-4xl tracking-widest">
            {selectedServiceAccount.data.CURR_READ}
          </span>
        </div>
      </div>
      <div>
        <NeedHelp forMeterRead={true} className="py-4" />
        <Button
          className="w-full"
          iconUrl={meterReadIcon}
          onClick={submitMeterReadHandler}
          loading={loading}
          shouldBtnDisable={error && !overrideWarning ? true : false}
        >
          Submit Meter Read
        </Button>
      </div>
    </Card>
  );

  return !confirmation ? renderInputs() : renderConfirmation();
};

export default MeterRead;
